import { Action, createReducer, on } from "@ngrx/store";
import { User } from "../../core/model/user.model";
import { AuthenticationActions } from "./authentication.actions";
import { UserAction } from '../../user/state/user.action';

export const STORE_FEATURE_KEY_AUTHENTICATE = "authenticate";

export class AuthState {
  loading: boolean;
  isUserAuthenticated: boolean;
  isAdmin: boolean;
  viewSessionId: string;
  retryRequests: boolean;
  isAuthenticatedFromAdmin: boolean;
  username: string;
  user: User;
  userCustomFields: any;
  attempts: number;
  portalVersion: string;
  isPortalVersionChanged: boolean;
    isWebsocketSessionActive: boolean;
}

export const initializeAuthState: AuthState = {
  loading: false,
  isUserAuthenticated: false,
  isAdmin: false,
  viewSessionId: undefined,
  retryRequests: false,
  isAuthenticatedFromAdmin: false,
  username: undefined,
  user: undefined,
  userCustomFields: undefined,
  attempts: 0,
  portalVersion: undefined,
  isPortalVersionChanged: false,
    isWebsocketSessionActive: false
};

const reducer = createReducer(
  initializeAuthState,
  on(AuthenticationActions.loginUser, (state, payload) => ({
    ...state,
    loading: true,
  })),
  on(AuthenticationActions.loginUserFail, (state, payload) => ({
    ...state,
    loading: false,
    isUserAuthenticated: false,
    viewSessionId: undefined,
    attempts: 1,
  })),
  on(
    AuthenticationActions.loginUserSuccess,
    (
      state,
      { user, viewSessionId, portalVersion, isAuthenticatedFromAdmin }
    ) => ({
      ...state,
      loading: false,
      isUserAuthenticated: true,
      isAuthenticatedFromAdmin,
      isAdmin: user
        ? (user.userPermissionKeys as string[]).find(
            (key) => key === "admin"
          ) !== undefined
        : undefined,
      viewSessionId,
      username: user.userName,
      user,
      userCustomFields: user ? user.userCustomFields : undefined,
      attempts: 0,
      portalVersion,
        isWebsocketSessionActive: true
    })
  ),
  on(AuthenticationActions.sessionTimeout, (state, payload) => ({
    ...state,
    isUserAuthenticated: false,
    viewSessionId: undefined,
      isWebsocketSessionActive: false
  })),
  on(AuthenticationActions.websocketSessionTimeout, (state, payload) => ({
        ...state,
      isWebsocketSessionActive: false
  })),
  on(AuthenticationActions.retryFailedRequest, (state, payload) => ({
    ...state,
    retryRequests: true,
  })),
  on(AuthenticationActions.cancelFailedRequest, (state, payload) => ({
    ...state,
    retryRequests: false,
  })),
  on(AuthenticationActions.logoutUserSuccess, (state, payload) => ({
    ...state,
    isUserAuthenticated: false,
    isAuthenticatedFromAdmin: false,
    user: undefined,
    userCustomFields: undefined,
    isAdmin: false,
    viewSessionId: undefined,
    retryRequests: undefined,
    isWebsocketActive: false
  })),
  on(AuthenticationActions.resetFailedRequest, (state, payload) => ({
    ...state,
    retryRequests: undefined,
  })),
  on(
    AuthenticationActions.getLatestPortalVersionSuccess,
    (state, { isPortalVersionChanged }) => ({
      ...state,
      isPortalVersionChanged,
    })
  ),
    on(AuthenticationActions.sessionTimeout, (state, payload) => ({
        ...state,
        isUserAuthenticated: false,
        viewSessionId: undefined,
    })),
    on(UserAction.getUserCustomFieldsSuccess, (state, userCustomFields) => ({
        ...state,
        userCustomFields
    })),
);

// tslint:disable-next-line:only-arrow-functions
export function AuthenticationReducer(
  state: AuthState | undefined,
  action: Action
): AuthState {
  return reducer(state, action);
}
